import { useEffect, useMemo } from 'react';

import { FlagsmithProvider } from '@mint-lib/admin-routing-context';
import { useGlobalGridOptions } from '@mint-lib/ag-grid';
import { useTranslation } from '@mint-lib/i18n';
import {
  AmbiguousUserProfile,
  ProfileContext,
  ProfileService,
} from '@mint-lib/profile-helpers';

import { profile } from '../constants/profile.js';
import Index from './index.jsx';

export function SecuredLayout() {
  const { i18n } = useTranslation('@mint-admin/secured-layout');
  useGlobalGridOptions();

  const value = useMemo(() => {
    const service = {
      getProfileData: () => profile,
      setProfileData: (
        next:
          | AmbiguousUserProfile
          | ((p: AmbiguousUserProfile) => AmbiguousUserProfile),
      ) => {},
    } as ProfileService;

    return {
      profileData: profile,
      setProfileData: () => {},
      profileService: service,
    };
  }, []);

  useEffect(() => {
    i18n.changeLanguage('en');
  }, []);

  return (
    <ProfileContext.Provider value={value}>
      <FlagsmithProvider name="@mint/arm">
        <Index />
      </FlagsmithProvider>
    </ProfileContext.Provider>
  );
}
